export function classifyHealth({ criticalCount = 0, ageingCount = 0, totalOpen = 0 }) {
  const ageRatio = totalOpen > 0 ? ageingCount / totalOpen : 0;
  const critRatio = totalOpen > 0 ? criticalCount / totalOpen : 0;

  if (criticalCount > 20 || ageRatio > 0.35) return "critical";
  if (criticalCount > 10 || ageRatio > 0.25) return "at-risk";
  if (criticalCount > 3 || ageRatio > 0.15 || critRatio > 0.1) return "attention";
  return "healthy";
}

export function buildSituationText({ criticalCount = 0, ageingCount = 0, idleCount = 0, totalOpen = 0 }) {
  if (totalOpen === 0) {
    return "No open tickets found. Your board is clear.";
  }

  const parts = [];

  if (criticalCount > 0) {
    parts.push(
      `${criticalCount} critical ticket${criticalCount !== 1 ? "s" : ""} need${criticalCount === 1 ? "s" : ""} immediate attention`
    );
  }

  if (ageingCount > 0) {
    parts.push(
      `${ageingCount} ticket${ageingCount !== 1 ? "s are" : " is"} ageing past 14 days`
    );
  }

  if (idleCount > 0) {
    parts.push(
      `${idleCount} ticket${idleCount !== 1 ? "s have" : " has"} had no activity in 5+ days`
    );
  }

  if (parts.length === 0) {
    return `${totalOpen} open tickets across the board. No critical blockers detected.`;
  }

  const joined =
    parts.length === 1
      ? parts[0]
      : parts.slice(0, -1).join(", ") + " and " + parts[parts.length - 1];

  return `Across ${totalOpen} open tickets, ${joined}.`;
}

export function buildRecommendedActions({
  criticalCount = 0,
  ageingCount = 0,
  idleCount = 0,
  quickWinCount = 0,
  unassignedCount = 0,
}) {
  const actions = [];

  if (criticalCount > 0) {
    actions.push(
      `Triage ${criticalCount} critical ticket${criticalCount !== 1 ? "s" : ""} — assign owners and set resolution targets today`
    );
  }

  if (ageingCount > 0) {
    actions.push(
      `Review ${ageingCount} ageing ticket${ageingCount !== 1 ? "s" : ""} stuck past 14 days — unblock or re-scope`
    );
  }

  if (unassignedCount > 0) {
    actions.push(
      `Assign ownership to ${unassignedCount} unowned ticket${unassignedCount !== 1 ? "s" : ""} to prevent further drift`
    );
  }

  if (idleCount > 0 && actions.length < 3) {
    actions.push(
      `Follow up on ${idleCount} idle ticket${idleCount !== 1 ? "s" : ""} with no recent activity`
    );
  }

  if (quickWinCount > 0 && actions.length < 3) {
    actions.push(
      `Close ${quickWinCount} quick-win ticket${quickWinCount !== 1 ? "s" : ""} to reduce open count`
    );
  }

  if (actions.length === 0) {
    actions.push("Board looks healthy — maintain current velocity");
  }

  return actions.slice(0, 3);
}
